import LoadingScene from '@Scenes/Loading';
import StartScreenScene from '@Scenes/StartScreen';
import MainScene from '@Scenes/Main';
import RightHandedControlsScene from '@Scenes/Main/Controls/RightHandedControls';
import LeftHandedControlsScene from '@Scenes/Main/Controls/LeftHandedControls';
import DebugScene from '@Scenes/Debug';
import BaseControls from '@Scenes/Main/Controls/BaseControls';
import ScoreScene from '@Scenes/Main/Score';
import LeftRightControls from '@Scenes/Main/Controls/LeftRightControls';
import KeyboardControls from '@Scenes/Main/Controls/KeyboardControls';
import CountDownScene from '@Scenes/Main/CountDown';
import PlayersScene from '@Scenes/Main/Players';
import PlayerScene from '@Scenes/Main/Players/Player';
import ChallengersScene from '@Scenes/Main/Players/Challengers';
import CompleteScene from '@Scenes/Main/Complete';
import LeaderboardsScene from '@Scenes/Main/Leaderboards';
import LeaderboardScene from '@Scenes/Main/Leaderboards/Leaderboard';
import EndScoreScene from '@Scenes/Main/EndScore';
import PausedScene from '@Scenes/Main/Paused';
import ContinueScene from '@Scenes/Main/Continue';
import InterstitialScene from '@Scenes/Main/Interstitial'
import ControlsTutorial from '@Scenes/Main/Controls/Tutorial';
import FeatureNotAvailable from '@Scenes/Main/FeatureNotAvailable';

const Scenes = [
    LoadingScene, // <-- must be first
    StartScreenScene,
    MainScene,
    BaseControls,
    RightHandedControlsScene,
    LeftHandedControlsScene,
    LeftRightControls,
    KeyboardControls,
    ScoreScene,
    CountDownScene,
    DebugScene,
    CompleteScene,
    PlayersScene,
    PlayerScene,
    ChallengersScene,
    LeaderboardsScene,
    LeaderboardScene,
    EndScoreScene,
    PausedScene,
    ContinueScene,
    InterstitialScene,
    ControlsTutorial,
    FeatureNotAvailable
]

export default Scenes;